import { JSX } from 'react';
import { InView } from 'react-intersection-observer';

export default function Partners({
  analytics,
  onSectionView,
}: {
  analytics: {
    label: string;
    value: string;
  };
  onSectionView: (
    label: string,
    value: string,
    extraData?: Record<string, string>,
  ) => void;
}): JSX.Element {
  return (
    <section id="info-partners" className="pi-careplus__partners">
      <div className="pi-careplus__partners--content">
        <InView
          as="h2"
          triggerOnce={true}
          onChange={(inView: boolean) => {
            if (!inView) return;
            onSectionView(analytics.label, analytics.value);
          }}
          className="pi-careplus__partners--title"
        >
          Our Trusted Partners
        </InView>
        <p className="pi-careplus__partners--text">
          We partnered with Trupanion and Lemonade to offer you wellness +
          insurance options from insurers renowned for their customer
          satisfaction.
        </p>
      </div>
    </section>
  );
}
